import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tun-eye-icon',
  templateUrl: './eye-icon.component.html',
  styleUrls: ['./eye-icon.component.scss']
})
export class EyeIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
